import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { BrandModel } from '@/models/tables/brand.model';
import { BrandsService } from '@services/data-source-tables/brands.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-button-brand-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteBrandComponent extends ButtonComponent implements OnInit {
  static refreshTableList: Subject<any>;
  faIcon = faTrashCan;
  private brand: BrandModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected brandService: BrandsService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  static refreshTableListAction() {
    this.refreshTableList.next();
  }

  static setRefreshTableList(refreshTableList: Subject<any>) {
    this.refreshTableList = refreshTableList;

    return this;
  }

  ngOnInit() {
    this.brand = <BrandModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.brandService.deleteBrand(this.brand.id).subscribe({
          next: () => {
            this.toastr.success('Marca cancellato correttamente!');

            ButtonDeleteBrandComponent.refreshTableListAction();
          },
          error: (error) => {
            LoggerService.error('deleteBrand failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Marca.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa Marca?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata la Marca non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
